var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "actions-bar" },
    [
      _vm._l(_setup.props.buttons, function (button, index) {
        return _c(
          "div",
          { key: index },
          [
            !button.isContextMenuOption && button.hidden !== true
              ? _c(_setup.LfLabelButtonComponent, {
                  staticClass: "action-button",
                  attrs: {
                    text: button.tooltip,
                    action: () => _setup.executeAction(button.action, index),
                    prependIcon: button.prependIcon,
                    disabled: _setup.disabledButtons || !button.enabled,
                    variant: button.variant || _setup.LabelButtonVariant.SOLID,
                  },
                })
              : _vm._e(),
          ],
          1
        )
      }),
      _vm.showKebabMenu
        ? _c(_setup.LfCustomContextMenu, {
            attrs: { buttons: _setup.customContextMenuButtons },
            on: {
              "execute-action": _setup.executeActionKebab,
              opened: _setup.onKebabOpened,
            },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }